@if (links.length) {
    <nav id="mobile-content-navigation" class="mobile-content-navigation" [attr.aria-label]="ariaLabel">
        <div class="nav-bar">
            @if (activeLink) {
                <finder-button
                    class="active-link"
                    id="mobile-content-navigation-button"
                    theme="reversed"
                    ariaControls="mobile-content-navigation-menu"
                    [ariaExpanded]="displayedList"
                    [ariaHasPopup]="true"
                    (click)="displayList()">
                    @if (activeLink.icon) {
                        <finder-font-icon
                            [svgSrc]="activeLink.icon.src"
                            size="xs"
                        >
                        </finder-font-icon>
                    }
                    <span class="active-link-label">{{activeLink.title}}</span>
                    <finder-font-icon name="icon_expand-show-more" size="inherit" [class.reversed]="displayedList" class="active-link-expand-icon"></finder-font-icon>
                </finder-button>
            }
            @if (cta) {
                <finder-button
                    finderClickScrollTo
                    scrollId="{{cta.href}}"
                    offsetElement="#mobile-content-navigation"
                    class="cta"
                    [href]="cta.href"
                    theme="primary">
                    <span class="cta-label">{{cta.title}}</span>
                </finder-button>
            }
        </div>

        @if (displayedList) {
            <div
                class="list"
                id="mobile-content-navigation-menu"
                aria-labelledby="mobile-content-navigation-button"
                role="menu"
                @listState>
                @if (logo) {
                    <finder-picture class="logo" [picture]="logo"></finder-picture>
                }

                @for (link of links; track (link.href + '-' + $index)) {
                    <finder-anchor
                        finderClickScrollTo
                        scrollId="{{link.href}}"
                        offsetElement="#mobile-content-navigation"
                        class="link"
                        [href]="link.href"
                        role="menuitem"
                        [class.active]="link === activeLink"
                        (click)="handlePageAnchor($event, link)"
                    >
                        <div class="link-inner">
                            <div class="link-content">
                                @if (link.icon) {
                                    <finder-font-icon
                                        [svgSrc]="link.icon.src"
                                        size="xs"
                                    >
                                    </finder-font-icon>
                                }
                                <span class="link-label">{{link.title}}</span>
                            </div>
                        </div>
                    </finder-anchor>
                }
            </div>
        }
    </nav>
}
